import { loadBurstPair, type FlowThemeDefinition } from '../../definition';
import { lifePlanCardMotion } from './motion';
import { LifePlanOverlay } from './Overlay';
import { lifePlanChromeTone } from './palette';

/**
 * The Life Plan book. Written for the Life Plan course only (assignment is restricted to it): every question has
 * its own spread, and the learner's own words are written onto the pages as they answer.
 */
export const lifePlanTheme: FlowThemeDefinition = {
  id: 'life_plan',
  label: 'Life Plan',
  description: 'The Life Plan as a cloth-bound book on a lamplit desk, made only for the Life Plan course: a hand-drawn spread for every question, your own answers written onto the pages as you go, real page turns, and a book that closes when your plan is complete.',
  category: 'classic',
  Overlay: LifePlanOverlay,
  chromeTone: lifePlanChromeTone,
  swatch: 'linear-gradient(160deg, #3A2112 0%, #1B2B52 45%, #0E1A38 100%)',
  cardGlass: 'dense',
  cardMotion: lifePlanCardMotion,
  burstSize: 300,
  softwareFriendly: false,
  loadScene: () => import('./scene').then((module) => module.createLifePlanScene),
  loadBursts: () => loadBurstPair(import('./burst-step.json'), import('./burst-finale.json')),
};
